<template>
  <div
    :class="['MapInfoBox', 'details', boxclass]"
    v-if="openedInfoMarker"
    @click.stop
  >
    <!--IMAGE header-->
    <img
      class="header"
      :src="openedInfoMarker.image"
      :alt="openedInfoMarker.image_alt ? openedInfoMarker.image_alt : ''"
      v-if="openedInfoMarker.image"
    />
    <!--IMAGE header fallback-->
    <div class="header" v-if="!openedInfoMarker.image">
      <h2>
      	{{ openedInfoMarker.city }}
      	<span v-if="openedInfoMarker.year"> - {{ getLabel('infobox_year', 'Since') }} {{ openedInfoMarker.year }}</span>
      </h2>
      <div class="typeIcons">
        <img
          class="millIcon"
          v-if="openedInfoMarker.mill"
          :src="getTypeImg('mill')"
          :alt="getFacilityLabel('is_mill','Mill')"
        />
        <img
            v-if="openedInfoMarker.office"
            :src="getTypeImg('office')"
            :alt="getFacilityLabel('is_office', 'Office')"
        />
        <img
          v-if="openedInfoMarker.production"
          :src="getTypeImg('production')"
            :alt="getFacilityLabel('is_production','Production')"
        />
        <img
          v-if="openedInfoMarker.restaurant"
          :src="getTypeImg('restaurant')"
            :alt="getFacilityLabel('is_restaurant','Restaurant')"
        />
        <img
          v-if="openedInfoMarker.cc_center"
          :src="getTypeImg('cc_center')"
            :alt="getFacilityLabel('is_cc_center','Community collaboration center')"
        />

      </div>
      <div v-if="openedInfoMarker.image_alt" class="image_alt">
        {{ openedInfoMarker.image_alt }}
      </div>
    </div>
    <!--text content of the box -->
    <div
      :class="
        boxclass === 'modalbox' ? 'contentWrapperLimited' : 'contentWrapper'
      "
    >
      <!--Title-->
      <template v-if="openedInfoMarker.image">
        <h2>
        	{{ openedInfoMarker.city }}
        	<span v-if="openedInfoMarker.year"> - {{ getLabel('infobox_year', 'Since') }} {{ openedInfoMarker.year }}</span>
        </h2>
      </template>
      <!--Type icons-->
      <div class="typeIcons" v-if="openedInfoMarker.image">
        <img
          class="millIcon"
          v-if="openedInfoMarker.mill"
          :src="getTypeImg('mill', true)"
          :alt="getFacilityLabel('is_mill', 'Mill')"
        />
        <img
          class="officeIcon"
          v-if="openedInfoMarker.office"
          :src="getTypeImg('office', true)"
            :alt="getFacilityLabel('is_office', 'Office')"
        />
        <img
          v-if="openedInfoMarker.production"
          :src="getTypeImg('production', true)"
            :alt="getFacilityLabel('is_production', 'Production')"
        />
        <img
          v-if="openedInfoMarker.restaurant"
          :src="getTypeImg('restaurant')"
            :alt="getFacilityLabel('is_restaurant','Restaurant')"
        />
        <img
          v-if="openedInfoMarker.cc_center"
          :src="getTypeImg('cc_center')"
            :alt="getFacilityLabel('is_cc_center','Community collaboration center')"
        />

      </div>
      <div v-if="openedInfoMarker.image" class="image_alt_blue">
        {{ openedInfoMarker.image_alt }}
      </div>
      <!--Address-->
      <p v-html="openedInfoMarker.address"></p>
      <div v-if="openedInfoMarker.phone" class="contact">
        <img :src="getContactsImg('phone-icon-png')" />
        {{ getLabel('infobox_phone', 'Tel:') }} {{ openedInfoMarker.phone }}
      </div>
      <div v-if="openedInfoMarker.fax" class="contact">
        <img :src="getContactsImg('fax-icon-png')" />
        {{ getLabel('infobox_fax', 'Fax:') }} {{ openedInfoMarker.fax }}
      </div>
      <hr />
      <!--Divider and brands-->
      <div class="brands">
        <span
          class="brand"
          v-for="brand in openedInfoMarker.brands"
          :key="brand.slug"
        >
          <img v-if="getBrandUrl(brand)"
              :src="getBrandUrl(brand)"
              :alt="brand.name"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "MapInfoBox",
  props: {
    openedInfoMarker: { type: Object },
    boxclass: { type: String },
    labels: {type: Object}
  },
  methods: {
    getFacilityLabel(key, fallback){
      return this.labels
          && this.labels.facility
          && this.labels.facility[key]
          || fallback;
    },
    getLabel(key, fallback){
      return this.labels
          && this.labels[key]
          || fallback;
    },
    getBrandUrl(brand) {
      try {
        if (brand.image)
          return brand.image;
        else
          return `${this.$context["assetsRoot"]}img/${brand.slug}.png`;
      } catch (e) {
        return "";
      }
    },
    getTypeImg(name, dark = false) {
      try {
        return dark
          ? `${this.$context["assetsRoot"]}img/${name}-icon-dark.svg`
          : `${this.$context["assetsRoot"]}img/${name}-icon.svg`
      } catch (e) {
        return "";
      }
    },
    getContactsImg(name) {
      try {
        return `${this.$context["assetsRoot"]}img/${name}.png`
      } catch (e) {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/variables";
@import "~$scss/utility";

.modalbox {
  font-size: 14px;
  margin: auto;
  transform: translateY(10%);
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: $color-white;
  -webkit-box-shadow: 0px 1px 8px 0px rgba(50, 50, 50, 0.2);
  box-shadow: 0px 1px 8px 0px rgba(50, 50, 50, 0.2);
}
.infobox {
  font-size: 14px;
  z-index: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: $color-white;
  -webkit-box-shadow: 0px 1px 8px 0px rgba(50, 50, 50, 0.2);
  -moz-box-shadow: 0px 1px 8px 0px rgba(50, 50, 50, 0.2);
  box-shadow: 0px 1px 8px 0px rgba(50, 50, 50, 0.2);
}

.details {
  .header {
    width: 100%;
    height: 160px;
    object-fit: cover;
    background: #00317c;
    color: $color-white;
    h2 {
      padding: 30px 30px 0 30px;
      color: $color-white;
      font-weight: $bold;
    }
  }

  h2 {
    padding: 22px 30px 0 30px;
    color: $color-grey;
    font-weight: $bold;
  }

  .typeIcons {
    padding: 14px 0 0 30px;
    img {
      margin-right: 14px;
      width: 7%;
    }
    // fixes svg sizes
    .millIcon {
      width: 9%;
    }
    .officeIcon {
      width: 9%;
    }
  }

  p {
    padding: 22px;
    overflow-x: hidden;
  }

  .contact {
    padding: 0 22px 30px 22px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    max-height: 50px; // Safari fix
    img {
      width: 15px;
      height: 15px;
      margin-right: 10px;
    }
  }

  .brands {
    padding: 21px;
    .brand {
      display: inline-block;
      max-width: 33%;
      img {
        width: 100%;
        padding: 5px;
      }
    }
  }

  hr {
    color: #80828459;
    width: 80%;
    margin: auto;
  }

  // used as second title into the header fallback
  .image_alt {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: $color-white;
    padding-top: 19px;
    padding-bottom: 41px;
    @include fontRobotoSlab();
  }
  // used as second title into the text content
  .image_alt_blue {
    color: $color-blue;
    text-align: center;
    padding-top: 19px;
    font-size: 14px;
    @include fontRobotoSlab();
  }
}
.MapInfoBox {
  .contentWrapper {
    overflow-y: auto;
  }
  // text content is limited on mobile to avoid  mispositioning of the modal and close button caused by exernal scrollbars
  .contentWrapperLimited {
    overflow-y: auto;
    max-height: 375px;
  }
}
</style>
